let authData;
export const updateData = (data) => authData = data;
export const getDataFromStorage = () => {
    return {
        userInfo: authData.userInfo,
        source: authData.source,
        audience: authData.audience,
        country: authData.country
    };
};
